import { mergeStyleSets } from '@uifabric/merge-styles';
import { layout } from '../../theme.style';
import { pxToRem } from '../../utils';

export default mergeStyleSets({
  agreementModule: {
    marginBottom: '2rem',
  },
  addAgreement: {
    cursor: 'pointer',
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    flexWrap: 'wrap',
    flexDirection: 'column-reverse',
    selectors: {
      [layout.breakpoints.min.md]: {
        flexWrap: 'nowrap',
        flexDirection: 'row',
      },
      '.ms-Button': {
        marginLeft: pxToRem(16),
      },
    },
  },
  cancelButtonContainer: {
    flex: '1 1 100%',
    display: 'flex',
    justifyContent: 'flex-end',
    width: '100%',
    selectors: {
      [layout.breakpoints.min.md]: {
        flex: 'auto',
      },
    },
  },
  saveSubmitButtonContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    marginBottom: pxToRem(16),
    selectors: {
      [layout.breakpoints.min.md]: {
        marginBottom: 0,
      },
    },
  },
  saving: {
    marginRight: pxToRem(8),
    marginLeft: pxToRem(16),
  },
  actionRequired: {
    marginBottom: pxToRem(40),
  },
});
